import { Injectable } from '@angular/core';

@Injectable()
export class HelpService {

    private helpDisplayed: boolean = false;
    private helpData: Object;

    public enableHelpDisplay(helpDisplayed: boolean) {
        this.helpDisplayed = helpDisplayed;
    }

    public isHelpDisplayed(): boolean {
        return this.helpDisplayed;
    }

    public setHelpData(helpData): void {
        this.helpData = helpData;
    }

    public isHelpLoaded(){
        if (this.helpData === undefined)
            return false;
        else
            return true;
    }

    public getHelpContent(classname: string, attributename?: string, attributePath?: string) {
        let helpData;

        //First try with attribute Path key (used for sequence attributes and byte-string's digits in help data object)
        if (attributePath !== undefined) {
            helpData = this.helpData[attributePath];
        }

        //Then try with classname and attributename
        if (helpData === undefined) {
            //try with class (optionnaly + attribute name)
            let helpKey = classname;
            if (attributename) {
                helpKey += '/' + attributename;
            }
            helpData = this.helpData[helpKey];
        }

        if (helpData !== undefined && helpData !== '') {
            let enhancedhelp = '<p>' + helpData + '</p>';
            //for tables:
            enhancedhelp = enhancedhelp.replace(/---\n---/g, '------'); //to remove annoyaing \n in middle of table header/footer lines
            enhancedhelp = enhancedhelp.replace(/\n\|/g, '<br>|'); //end of header line
            enhancedhelp = enhancedhelp.replace(/\|\n/g, '|<br>'); //end of intermediate line
            enhancedhelp = enhancedhelp.replace(/\n---/g, '<br><pre>---'); //beginning of table
            enhancedhelp = enhancedhelp.replace(/---\n/g, '---</pre><br>'); //end of table

            //for bullets:
            enhancedhelp = enhancedhelp.replace(/\n  -/g,     '<br>&nbsp;&nbsp;&bull;');
            enhancedhelp = enhancedhelp.replace(/\n      -/g, '<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&bull;');
            enhancedhelp = enhancedhelp.replace(/\n-/g,       '<br>&bull;');

            //for separating paragraphs:
            enhancedhelp = enhancedhelp.replace(/\.\n/g, '.</p><p>');
            enhancedhelp = enhancedhelp.replace(/:\n/g, ':</p><p>');
            return enhancedhelp;
        }

        return '';
    }
}
